import { ref } from "vue";

export const showModalAddressHappy = ref<boolean>(false)
export const showModalAddressHappyTransition = ref<boolean>(false)